import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

import styles from "./selection.scss";
import history from "../../history";
import { selectCategories } from "../App/selectors";
import BreadcrumbBar from "../../components/BreadcrumbBar";
import HelmetComponent from "../../utils/HelmetHelper";
import { buildPricesResultsUrl, isPropertyTypeSlug, LocationOption, PRICES_BASE_PATH } from "./helpers";
import PricesSelectionForm from "./PricesSelectionForm";

interface SelectionProps {
  location?: {
    search?: string;
  };
}

const Selection = (props: SelectionProps) => {
  const routerLocation = props.location;
  const categories = useSelector(selectCategories);

  // Determine initial property type from URL query param
  const initialPropertyType = useMemo(() => {
    const search = (routerLocation && routerLocation.search) || (typeof window !== "undefined" ? window.location.search : "");
    const params = new URLSearchParams(search);
    const fromQuery = params.get("kategorija");
    if (isPropertyTypeSlug(fromQuery, categories)) {
      return fromQuery;
    }
    return undefined;
  }, [routerLocation, categories]);

  useEffect(() => {
    if (routerLocation && routerLocation.search && routerLocation.search.includes("kategorija=")) {
      history.replace(PRICES_BASE_PATH);
    }
  }, []);

  const handleSubmit = (propertyType: string, selectedLocation: LocationOption) => {
    ReactGA.event({
      category: "Kretanje cijena nekretnina",
      action: "Click",
      label: "Prikaz cijena"
    });

    history.push(buildPricesResultsUrl(propertyType, selectedLocation.route));
  };

  return (
    <React.Fragment>
      <HelmetComponent title={"Prosječne cijene nekretnina | INDEX OGLASI"} />
      <BreadcrumbBar
        className={styles.breadcrumb}
        routeLinks={[{ title: "Prosječne cijene nekretnina" }]}
        category={"prosjecne-cijene-nekretnina"}
      />
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1 className={styles.title}>{"Prosječne cijene nekretnina"}</h1>
          <p className={styles.subtitle}>
            {"Saznajte prosječnu cijenu po m² na temelju oglasa objavljenih na Index Oglasima"}
          </p>

          <PricesSelectionForm
            categories={categories || []}
            initialPropertyType={initialPropertyType}
            onSubmit={handleSubmit}
          />

          <p className={styles.info}>
            {"Podaci se temelje isključivo na oglasima objavljenim na Index Oglasi"}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Selection;



// WEBPACK FOOTER //
// ./src/containers/RealEstatePricesPage/Selection.tsx